<template>
  <RevCard class="p-24">
    <div class="mb-24 flex items-center justify-between">
      <div class="body-1 flex items-center gap-8">
        <IconStarOutlined />
        {{ i18n(translations.title) }}
      </div>
    </div>

    <RevLoadingScreen
      v-if="status === 'pending'"
      class="mt-32"
      :text="i18n(translations.loading)"
    />

    <div v-else class="space-y-12">
      <RevRating
        v-if="rating?.averageRate"
        :score="rating.averageRate"
        size="medium"
      />

      <div>{{ i18n(translations.description) }}</div>

      <RevButton
        class="w-full md:w-auto"
        size="small"
        :to="{ type: 'internal', name: ROUTE_NAMES.CUSTOMER_REVIEWS.INDEX }"
        :tracking="{
          name: 'bo-see-all-reviews',
          page_type: 'bo_merchant_home',
          zone: 'reviews-banner',
        }"
        variant="secondary"
      >
        {{ i18n(translations.seeReviewsButton) }}
      </RevButton>
    </div>
  </RevCard>
</template>

<script setup lang="ts">
import { type Error, getApiErrorMessage, useAsyncData } from '#imports'
import { watch } from 'vue'

import { useHttpFetch } from '@backmarket/nuxt-module-http-v2/useHttpFetch'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useTheToast } from '@backmarket/nuxt-module-toast/useTheToast'
import { RevButton } from '@ds/components/Button'
import { RevCard } from '@ds/components/Card'
import { RevLoadingScreen } from '@ds/components/LoadingScreen'
import { RevRating } from '@ds/components/Rating'
import { IconStarOutlined } from '@ds/icons/IconStarOutlined'

import { ROUTE_NAMES } from '~/constants/routes'
import { useSellerInfoStore } from '~/scopes/auth/stores/sellerInfoStore'

import translations from './CustomerReviews.translations'

const $httpFetch = useHttpFetch()
const i18n = useI18n()
const { openErrorToast } = useTheToast()
const { publicId } = useSellerInfoStore()

const {
  data: rating,
  error: ratingError,
  status,
} = useAsyncData(() =>
  $httpFetch('/reviews/v1/sellers/:uuid/products/reviews-summary', {
    pathParams: { uuid: publicId || '' },
  }),
)

watch(
  () => ratingError.value,
  (err) => {
    if (err) {
      openErrorToast({
        content: getApiErrorMessage(ratingError.value as unknown as Error),
      })
    }
  },
)
</script>
